import { Instance } from 'mobx-state-tree'
import { CancelUserSubscriptionResponseModelBase } from './CancelUserSubscriptionResponseModel.base'

/* The TypeScript type of an instance of CancelUserSubscriptionResponseModel */
export interface CancelUserSubscriptionResponseModelType
  extends Instance<typeof CancelUserSubscriptionResponseModel.Type> {}

/* A graphql query fragment builders for CancelUserSubscriptionResponseModel */
export {
  selectFromCancelUserSubscriptionResponse,
  cancelUserSubscriptionResponseModelPrimitives,
  CancelUserSubscriptionResponseModelSelector
} from './CancelUserSubscriptionResponseModel.base'

/**
 * CancelUserSubscriptionResponseModel
 */
export const CancelUserSubscriptionResponseModel = CancelUserSubscriptionResponseModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
